import { useState } from "react";
import { AxiosResponse } from "axios";
import { saveBlobResponse } from "../../utils/downloadBlob";

/** Run one xlsx download at a time per key; the interceptor reports failures. */
export function useBlobExport() {
  const [busy, setBusy] = useState<string | null>(null);

  const run = async (key: string, request: () => Promise<AxiosResponse>, fallbackName: string) => {
    setBusy(key);
    try {
      const response = await request();
      saveBlobResponse(response, fallbackName);
    } catch {
      // global error alert already shown
    } finally {
      setBusy(null);
    }
  };

  return { busy, run };
}
